const DEV_MODE = process.env.NODE_ENV === "development";
const URL = process.env.REACT_APP_API_ENDPOINT || window.location.origin;

export default function ApiURL() {
  if (DEV_MODE) return "https://test.ambulanzpartner.de/rs2/controlling/";
  return `${URL}/rs2/controlling/`;
}
